import React from 'react';
import { FlameIcon } from 'lucide-react';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
  spotsLeft?: number;
};
export function ScarcityBar({
  tone = 'light',
  spotsLeft = 9
}: ScarcityBarProps) {
  const isDark = tone === 'dark';
  return <div className={`w-full max-w-xl rounded-xl border px-4 py-3 ${isDark ? 'border-white/15 bg-white/[0.06]' : 'border-navy-900/10 bg-navy-50'}`} data-id="element-268" data-mp="2l4o397p283gl">
      <div className="flex items-center justify-between gap-3" data-id="element-269" data-mp="2b5f9aeu72ou8">
        <p className={`flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-[0.1em] sm:text-xs ${isDark ? 'text-gold-300' : 'text-navy-800'}`} data-id="element-270" data-mp="2g6399q0eig0l">
          <FlameIcon className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-271" data-mp="2766gbc6zauzq" />
          Restano {spotsLeft} posti a 19 EUR
        </p>
        <span className={`text-[11px] font-bold tabular-nums ${isDark ? 'text-white/60' : 'text-navy-800/60'}`} data-id="element-272" data-mp="cmb4utjmvh6">
          93%
        </span>
      </div>
      <div className={`mt-2 h-2.5 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/15' : 'bg-navy-900/10'}`} role="progressbar" aria-valuenow={93} aria-valuemin={0} aria-valuemax={100} aria-label="Posti al prezzo promozionale già assegnati" data-id="element-273" data-mp="33ks614rzlxm8">
        <div className="h-full w-[93%] rounded-full bg-red-500" data-id="element-274" data-mp="2knr09hqlzth8" />
      </div>
      <p className={`mt-2 text-[11px] leading-snug ${isDark ? 'text-white/60' : 'text-navy-900/60'}`} data-id="element-275" data-mp="2kpu16wtav70q">
        Il prezzo promozionale si chiude quando la barra si riempie.
      </p>
    </div>;
}